export default {"src":"/_next/static/media/COUR.4bc0818f.svg","height":18,"width":18};